import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { cn } from '@/libs/utils/cn';

function Dropdown({ children, ...props }: React.ComponentProps<typeof DropdownMenu.Root>) {
  return <DropdownMenu.Root {...props}>{children}</DropdownMenu.Root>;
}

function DropdownTrigger({
  className,
  ...props
}: React.ComponentProps<typeof DropdownMenu.Trigger>) {
  return <DropdownMenu.Trigger className={cn('outline-none', className)} {...props} />;
}

function DropdownContent({
  className,
  ...props
}: React.ComponentProps<typeof DropdownMenu.Content>) {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        sideOffset={8}
        className={cn(
          'z-50 bg-background border-input border rounded-lg shadow-lg py-2 min-w-56 text-sm',
          'data-[side=bottom]:animate-in data-[side=bottom]:slide-in-from-top-2',
          'data-[side=top]:animate-in data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      />
    </DropdownMenu.Portal>
  );
}

function DropdownItem({
  className,
  disabled,
  ...props
}: React.ComponentProps<typeof DropdownMenu.Item>) {
  return (
    <DropdownMenu.Item
      className={cn(
        'px-3 py-2 cursor-pointer select-none outline-none hover:bg-accent hover:text-accent-foreground',
        disabled && 'cursor-not-allowed opacity-50 hover:bg-transparent',
        className,
      )}
      disabled={disabled}
      {...props}
    />
  );
}

function DropdownSeparator({
  className,
  ...props
}: React.ComponentProps<typeof DropdownMenu.Separator>) {
  return <DropdownMenu.Separator className={cn('h-px my-1 bg-border', className)} {...props} />;
}

export { Dropdown, DropdownContent, DropdownItem, DropdownSeparator, DropdownTrigger };
